import React, { useRef, useEffect } from "react";
import { HeroArea } from "../../components/heroArea";

import { IoT as iot } from "../../assets/expertise";
import { useTranslation } from "react-i18next";
import "./expertise.css";

export const IoT = () => {
  const { t } = useTranslation();
  const section = useRef(null);
  useEffect(() => {
    section.current.scrollIntoView();
  }, []);
  return (
    <>
      <HeroArea />
      <div ref={section} className="service--container container">
        <h2>{t("service.iot.title1")}</h2>
        <div className="service--content">
          <p className="paragraph">{t("service.iot.paragraph1")}</p>
          <img src={iot} alt="iot" className="service--img" />
        </div>
        <br />
        <div className="service--second--content">
          <h3>{t("service.methodology")}</h3>
          <h4>1 - {t("service.iot.title2")}</h4>
          <p className="paragraph">{t("service.iot.paragraph2")}</p>
          <h4>2 - {t("service.iot.title3")}</h4>
          <p className="paragraph">{t("service.iot.paragraph3")}</p>
          <h4>3 - {t("service.iot.title4")}</h4>
          <p className="paragraph">{t("service.iot.paragraph4")}</p>
          <h4>4 - {t("service.iot.title5")}</h4>
          <p className="paragraph">{t("service.iot.paragraph5")}</p>
          <h4>5 - {t("service.iot.title6")}</h4>
          <p className="paragraph">{t("service.iot.paragraph6")}</p>
          <h4>6 - {t("service.iot.title7")}</h4>
          <p className="paragraph">{t("service.iot.paragraph7")}</p>
          <h4>7 - {t("service.iot.title8")}</h4>
          <p className="paragraph">{t("service.iot.paragraph8")}</p>
        </div>
      </div>
    </>
  );
};
